import { combineReducers } from "redux";
import posReducer from "./posReducer";
import userReducer from "./userReducer";
import modalReducer from "./modalReducer";
import filterReducer from "./filterReducer";
import interfaceReducer from "./interfaceReducer";
import receiveReducer from "./receiveReducer";

const rootReducers = combineReducers({
  pos: posReducer,
  user: userReducer,
  modal: modalReducer,
  filter: filterReducer,
  receive: receiveReducer,
  interface: interfaceReducer,
});

export default rootReducers;
